import { render, staticRenderFns } from "./Accountant.vue?vue&type=template&id=2d5e2d62&scoped=true&"
import script from "./Accountant.vue?vue&type=script&lang=js&"
export * from "./Accountant.vue?vue&type=script&lang=js&"
import style0 from "./Accountant.vue?vue&type=style&index=0&id=2d5e2d62&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5e2d62",
  null
  
)

export default component.exports